import { CheckCircle } from "lucide-react";
import { Button } from "../../../components/ui/button";
import { useNavigate } from "react-router-dom";

const RegisterApproved = () => {
  const navigate = useNavigate();

  const handleGoToLogin = () => {
    navigate("/");
  };

  return (
    <div className="flex flex-col items-center justify-center gap-4 sm:gap-6 text-black03 px-4">
      <div className="flex flex-col items-center gap-3 sm:gap-4 text-center max-w-md">
        <CheckCircle className="h-12 w-12 sm:h-16 sm:w-16 text-green-500" />
        <h2 className="text-lg sm:text-2xl font-semibold text-green-600">
          Cadastro Aprovado
        </h2>
        <p className="text-xs sm:text-sm leading-relaxed">
          Parabéns! Seu cadastro foi aprovado com sucesso. Bem-vindo à nossa
          comunidade!
        </p>

        <Button
          type="button"
          onClick={handleGoToLogin}
          className="mt-2 sm:mt-4 h-11 sm:h-12 bg-primary px-6 sm:px-8 text-white hover:bg-primary/90 text-sm sm:text-base w-full sm:w-auto"
        >
          Continue
        </Button>
      </div>
    </div>
  );
};

export default RegisterApproved;
